import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React, { useContext, useEffect, useRef, useState } from "react";
import { delimitationService } from "../../services/DelimitationService";
import { reportService } from "../../services/ReportService";
import Viewer, { Worker, defaultLayout } from "@phuocng/react-pdf-viewer";
import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";
import { Dialog } from "primereact/dialog";
import ReportFilter from "./ReportFilter";
import { AppDB } from "../../App";
import { Accordion, AccordionTab } from "primereact/accordion";
import { helper } from "../../componets/utils/helper";
import registerManagementReportService from "../../services/RegisterManagementReportService";

export const Reports = ({
	isPortal = false,
	reportType = "application",
	GenerateReportBtnTittle,
	InludeVillageOnSortConfig,
	customDownload = true
}) => {
	var [reportName, setReportName] = useState("");
	var [loading, setLoading] = useState(false);
	var [activeIndex, setActiveIndex] = useState(0);

	var { toast } = useContext(AppDB);

	const [showDialog, setShowDialog] = useState(false);

	function downloadUint8Array(data, filename, mimeType = "application/octet-stream") {
		console.log(data);
		// Convert Uint8Array → Blob
		const blob = new Blob([data], { type: mimeType });

		// Create temporary URL
		// const url = URL.createObjectURL(data);

		// Create hidden link
		const a = document.createElement("a");
		a.href = data;
		a.download = filename;

		// Trigger download
		document.body.appendChild(a);
		a.click();

		// Cleanup
		document.body.removeChild(a);
		// URL.revokeObjectURL(url);
	}

	const [bytePdf, setBytePdf] = useState(null);
	function SubmitFilter(report_data) {
		setLoading(true);
		if (report_data?.voterRegisterID) {
			var payload = {
				mergeFiles: true,
				demarcationList: [
					{
						DelimitationLevelID: report_data?.delimitationLevelID,
						DelimitationID: report_data?.delimitationID,
						voterRegisterID: report_data?.voterRegisterID
					}
				],
				voterRegisterID: report_data?.voterRegisterID
			};
			registerManagementReportService
				.viewdownloadDelimitationReport(payload)
				.then((res) => {
					if (res?.success === true) {
						var data = helper.base64ToFileUrl(res.data);
						setBytePdf(data);
						setShowDialog(true);
						setActiveIndex(1);
						toast.show({ severity: "success", summary: "Success", detail: "Report Loaded", life: 5000 });
					} else {
						setActiveIndex(0);
						toast.show({ severity: "error", summary: "", detail: "No Data Found", life: 3000 });
					}
					setLoading(false);
				})
				.catch((err) => {
					setLoading(false);
					return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
				});
		} else {
			reportService.getReport(report_data).then((res) => {
				if (res?.success === true) {
					var data = helper.base64ToFileUrl(res.data);
					setBytePdf(data);
					setShowDialog(true);
					setActiveIndex(1);
					toast.show({ severity: "success", summary: "Success", detail: "Report Loaded", life: 5000 });
				} else {
					setActiveIndex(0);
					toast.show({ severity: "error", summary: "", detail: "No Data Found", life: 3000 });
				}
				setLoading(false);
			});
		}
	}

	var [documentLoaded, setDocumentLoaded] = useState(false);

	useEffect(() => {
		if (!customDownload) return;
		if (!documentLoaded) return;
		if (!reportName) return;

		const toolbar = document.querySelector(".viewer-toolbar-right");
		if (!toolbar) return;

		const fileButton = toolbar.querySelector(".viewer-open-file");
		if (!fileButton) return;

		const items = Array.from(toolbar.children);

		const fileIndex = items.findIndex((el) => el.contains(fileButton));

		let targetButton = null;

		for (let i = fileIndex + 1; i < items.length; i++) {
			const btn = items[i].querySelector?.(".viewer-button");
			if (btn) {
				targetButton = btn;
				break;
			}
		}

		if (!targetButton) return;

		const newButton = document.createElement("button");
		newButton.className = "viewer-button";

		newButton.innerHTML = `
		  <svg class="viewer-icon" height="16px" viewBox="0 0 24 24" width="16px">
			<path d="M17.5,11.5c3.314,0,6,2.686,6,6s-2.686,6-6,6s-6-2.686-6-6S14.186,11.5,17.5,11.5z
					  M17.5,14.5v6
					  M17.5,20.5
					  l-2.25-2.25
					  M17.5,20.5l2.25-2.25
					  M10.5,23.5h-9c-0.552,0-1-0.448-1-1v-21c0-0.552,0.448-1,1-1h13.293
					  c0.265,0,0.52,0.105,0.707,0.293L19.207,4.5C19.395,4.687,19.5,4.942,19.5,5.207V8.5"></path>
		  </svg>
		`;

		var callBack = async (e) => {
			e.preventDefault();
			downloadUint8Array(bytePdf, reportName + ".pdf");
			// const typeInfo = await fileTypeFromStream(bytePdf);
			// if (typeInfo) {
			// 	console.log(`MIME: ${typeInfo.mime}`); // e.g. "image/png"
			// 	console.log(`Extension: ${typeInfo.ext}`); // e.g. "png"
			// }
			console.log("button clicked");
		};

		newButton.addEventListener("click", callBack);

		targetButton.replaceWith(newButton);

		return () => {
			newButton.removeEventListener("click", callBack);
			newButton.replaceWith(targetButton);
		};
	}, [documentLoaded, showDialog]);

	return (
		<div className="grid">
			<div className="col-12">
				<Dialog
					draggable={false}
					maximizable={false}
					maximized
					showHeader={false}
					header={
						<b>
							<h5>{reportName} Report</h5>
						</b>
					}
					style={{ width: "75%", height: "75%" }}
					modal
					visible={showDialog}
					onHide={(e) => {
						setShowDialog(false);
						setDocumentLoaded(false);
					}}
					footer={
						<>
							<Button
								className="my-2  p-button-danger"
								label="Close"
								onClick={() => {
									setShowDialog(false);
								}}
								icon="pi pi-times"
							/>
						</>
					}
				>
					<div style={{ marginTop: 10 }} className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
						<b>
							<h5>{reportName} Report</h5>
						</b>
					</div>

					<Worker workerUrl="script/pdf.worker.min.js">
						<Viewer
							onDocumentLoad={(e) => {
								console.log(e);
								setDocumentLoaded(true);
							}}
							zoomInButton={true}
							defaultScale={1}
							fileUrl={bytePdf}
						/>
					</Worker>
				</Dialog>

				<div className="card">
					<div className="grid">
						<div className="col-12">
							<h3>{isPortal ? "Voter's Register" : `${reportType?.Name}`}</h3>
						</div>
						<div className="col-12">
							<ReportFilter
								reportType={reportType}
								isPortal={isPortal}
								loading={loading}
								GenerateReportBtnTittle={GenerateReportBtnTittle}
								InludeVillageOnSortConfig={InludeVillageOnSortConfig}
								onSubmit={(data, name) => {
									setReportName(name);
									SubmitFilter(data);
								}}
							/>
						</div>

						{/* <div className="col-12">
							<Accordion activeIndex={activeIndex}>
								<AccordionTab header="Header I">
									<div className="col-12">
										<ReportFilter loading={loading} onSubmit={(data, name) => {
											setReportName(name)
											SubmitFilter(data)
										}} />
									</div>
								</AccordionTab>
								<AccordionTab header="Header II">
									<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js">
										{bytePdf !== null && <Viewer zoomInButton={true} defaultScale={1} onDocumentLoad={console.log} fileUrl={bytePdf} />}

									</Worker>
								</AccordionTab>
							</Accordion>

						</div> */}
					</div>
				</div>
			</div>
		</div>
	);
};
